import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 2.5c-.943 0-1.414 0-1.707.293S4 3.557 4 4.5v11c0 .943 0 1.414.293 1.707S5.057 17.5 6 17.5h8c.943 0 1.414 0 1.707-.293S16 16.443 16 15.5V7.914c0-.265 0-.398-.052-.52-.052-.124-.148-.22-.342-.414L12.52 3.893c-.194-.193-.29-.29-.413-.342s-.256-.052-.521-.052H6Z",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 3.5v2c0 .943 0 1.414.293 1.707S13.057 7.5 14 7.5h2M7 14.5a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1M10 14.5a1 1 0 0 1-1-1v-4a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1M13 14.5a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1"
    }, null, -1)
  ])))
}
export default { render: render }